import React from "react";

const PendingApproval: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-400/40 via-indigo-200/60 to-blue-100/90 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white/30 backdrop-blur-lg border border-white/40 rounded-3xl shadow-2xl p-8 glassmorphism text-center">
        <img
          src="/assets/images/logo.png"
          alt="Logo"
          className="w-20 h-20 mb-4 rounded-full shadow-md mx-auto"
        />
        <h2 className="text-2xl font-bold text-blue-800 mb-2">Please wait for admin confirmation</h2>
        <p className="text-gray-700 text-base mb-4">
          Your account has been created and is pending approval by an admin.<br/>
          You will be able to log in once your account is confirmed.
        </p>
      </div>
    </div>
  );
};

export default PendingApproval;
